import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import * as TagList from 'types/_general/Store/TagList';

const rb = new ReducerBuilder<TagList.Type>();
export const createTagListLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'TagList/LoadedFromBackend'
);

export const tagListReducer = rb.createReducer();
